import type { WorkingTime, WorkingTimeDto } from '../types';

function formatTime(value: string | null): string {
  return value ? value.slice(0, 5) : '';
}

export function workingTimeFromDto(workingtime: WorkingTimeDto): WorkingTime {
  return {
    id: workingtime.id,
    weekDay: workingtime.dewt_weekday,
    starTimeMorning: formatTime(workingtime.dewt_start_time_morning),
    endTimeMorning: formatTime(workingtime.dewt_end_time_morning),
    startTimeAfternoon: formatTime(workingtime.dewt_start_time_afternoon),
    endTimeAfternoon: formatTime(workingtime.dewt_end_time_afternoon),
  };
}
